import { RefObject, useEffect } from 'react'

export const useHandleOutsideClick = (params: {
  insideElements: Array<RefObject<HTMLElement | null>>
  onOutsideClick: () => void
}) => {
  useEffect(() => {
    const isOutsideClick = (target: Node) =>
      !params.insideElements.some((ref) => ref.current?.contains(target))

    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as Node
      if (isOutsideClick(target)) {
        params.onOutsideClick()
      }
    }

    document.addEventListener('mousedown', handleOutsideClick, true)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick, true)
    }
  }, [params])
}
